import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconMaximize",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  d: "M7.5 1a.5.5 0 0 0 0 1h1.793L6.647 4.647a.5.5 0 0 0 .707.707L10 2.707V4.5a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5h-3ZM2 7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 .5.5h3a.5.5 0 1 0 0-1H2.707l2.647-2.646a.5.5 0 0 0-.707-.707L2 9.293V7.5Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function h(e, u, i, f, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--maximize"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Maximize",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const g = /* @__PURE__ */ o(l, [["render", h]]);
export {
  g as default
};
//# sourceMappingURL=maximize.js.map
